var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _g, _path116, _g2, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOfferReviewComparisonSolarHouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 410,
    height: 273,
    viewBox: "0 0 410 273",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M326.273 147.371V223.568L206.375 258.202V179.581L326.273 147.371Z",
    fill: "#B8B2BA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M206.375 179.553V176.956L272.215 129.334L326.273 144.918V147.343L206.375 179.553Z",
    fill: "#673929"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M202.043 259.733L69.8438 207.954V134.797L199.19 182.153L202.043 180.089V259.733Z",
    fill: "#EADFDB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8438 209.544L202.757 261.602V259.63L202.043 259.732L69.8438 207.953V209.544Z",
    fill: "#030511"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M86.35 210.68L0 176.861L22.5842 170.92V171.666L2.57117 176.943L85.2721 209.332L86.35 210.68Z",
    fill: "#3A4072"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M199.19 182.155L63.4677 132.463L62.7129 130.748L198.116 180.321L199.19 182.155Z",
    fill: "#030511"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M203.16 179.277L202.755 259.633L202.043 259.735V180.091L203.16 179.277Z",
    fill: "#030511"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M331.433 146.406L272.215 129.333L199.189 182.153L198.119 180.317L272.215 126.723L332.743 144.918L331.433 146.406Z",
    fill: "#030511"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M326.273 223.538V144.918L327.893 145.38V223.069L326.273 223.538Z",
    fill: "#030511"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M272.215 126.725L135.943 80.0391L62.7129 130.748L198.12 180.319L272.215 126.725Z",
    fill: "#131B3E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M203.159 179.275L206.374 176.957V258.175V260.561L202.756 261.604L203.159 179.275Z",
    fill: "#030511"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2174 218.676V161.825L118.073 170.009V226.844L119.241 227.277V169.163L96.2949 160.311V218.314L97.2174 218.676Z",
    fill: "#030511"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M120.283 227.659V168.934L119.242 169.165V227.279L120.283 227.659Z",
    fill: "#030511"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M120.282 168.934L97.4179 160.129L96.2949 160.313L119.241 169.165L120.282 168.934Z",
    fill: "#030511"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3052 162.646V218.691L97.2168 218.677V161.826L99.3052 162.646Z",
    fill: "url(#paint0_linear_1415_3219)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M144.059 216.713V179.501L187.998 196.188V233.496L189.166 233.929V195.341L143.137 177.986V216.352L144.059 216.713Z",
    fill: "#030511"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M190.205 233.582V195.035L189.166 195.266V233.93L190.205 233.582Z",
    fill: "#030511"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M143.137 177.989L144.26 177.805L190.205 195.037L189.166 195.344L143.137 177.989Z",
    fill: "#030511"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M146.145 180.322V214.418L144.057 215.334V179.502L146.145 180.322Z",
    fill: "url(#paint1_linear_1415_3219)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3052 218.692L118.073 225.704V226.845L97.2168 218.678L99.3052 218.692Z",
    fill: "url(#paint2_linear_1415_3219)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M187.996 233.498L144.057 216.716V215.342L187.996 232.126V233.498Z",
    fill: "#030511"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M146.145 214.418L187.996 230.315V232.125L144.057 215.334L146.145 214.418Z",
    fill: "url(#paint3_linear_1415_3219)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M150.653 182.007V213.756L166.027 219.622V187.893L168.755 188.888V220.658L187.22 227.673V195.892L187.997 196.189V230.316L146.146 214.419V180.322L150.653 182.007Z",
    fill: "#20130C"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M153.459 183.071V212.647L166.028 217.497V219.621L150.654 213.755V182.006L153.459 183.071Z",
    fill: "#875532"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M168.756 188.889V218.692L187.22 225.676V195.893L168.756 188.889Z",
    fill: "#DFB26F"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M168.756 218.693L187.22 225.677V227.674L168.756 220.66V218.693Z",
    fill: "#875532"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M184.543 201.662L172.992 205.068L181.712 208.648L178.767 218.864L180.616 219.504L183.33 213.15L181.078 219.622L181.424 219.759L184.081 213.235L187.219 214.485V211.216L184.889 211.909L185.496 209.917L187.219 210.523V202.789L184.543 201.662Z",
    fill: "#291D1D"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M182.162 193.975L183.211 202.056L184.543 201.664L187.219 202.79V195.894L182.162 193.975Z",
    fill: "#7E5B42"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M153.455 193.349V212.649L166.025 217.498V187.893L153.455 183.072V193.349Z",
    fill: "#DFB26F"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M168.756 199.18C168.756 199.294 172.994 205.068 172.994 205.068L181.716 208.647L178.771 218.865L171.926 216.181L170.906 219.505L168.756 218.691V199.18Z",
    fill: "#BA7E45"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M178.767 218.863L178.098 222.226L179.245 222.659L180.104 222.984L180.626 223.18L181.943 222.847L181.569 219.989L184.34 221.021L184.543 224.663L185.801 225.139V221.056L187.218 220.711V214.483L184.081 213.234L181.424 219.758L181.078 219.621L183.33 213.148L180.616 219.502L178.767 218.863Z",
    fill: "#BA7E45"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M185.496 209.918L184.889 211.909L187.218 211.216V210.523L185.496 209.918Z",
    fill: "#BA7E45"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M168.756 199.18L179.722 203.085L183.213 202.055L182.164 193.973L168.756 188.889V199.18Z",
    fill: "#C9945A"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M153.455 183.072V193.349L166.025 198.084V187.893L153.455 183.072Z",
    fill: "#C9945A"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M166.026 206.855L163.982 207.665L166.026 208.818V206.855Z",
    fill: "#BA7E45"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3066 162.646V218.692L118.074 225.704V170.01L99.3066 162.646Z",
    fill: "#28202F"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M102.242 178.602V216.325L107.209 218.288V180.626L102.242 178.602Z",
    fill: "#20130C"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M109.363 168.934V206.657L114.33 208.62V170.958L109.363 168.934Z",
    fill: "#20130C"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M104.725 179.614V215.342L107.209 216.439V218.288L102.242 216.325V178.602L104.725 179.614Z",
    fill: "#875532"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M104.727 179.613V215.341L107.21 216.439V180.625L104.727 179.613Z",
    fill: "#C9945A"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M107.21 214.104L104.727 215.342L107.21 216.44V214.104Z",
    fill: "#BA7E45"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M109.363 168.934L111.846 169.946V205.96L114.33 207.283V208.62L109.363 206.657V168.934Z",
    fill: "#875532"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M111.844 169.943V186.247L114.327 185.788V170.955L111.844 169.943Z",
    fill: "#BA7E45"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M111.844 199.953L114.327 199.182V185.791L111.844 186.251V199.953Z",
    fill: "#C9945A"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M114.327 207.282L111.844 205.959V199.95L114.327 199.18V207.282Z",
    fill: "#BA7E45"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8438 134.797L90.4581 142.345V216.037L69.8438 207.954V134.797Z",
    fill: "#C1865C"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8438 180.32V187.676L90.4581 195.68V188.001L69.8438 180.32Z",
    fill: "#875532",
    fillOpacity: 0.6
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8438 145.285V152.641L90.4581 160.645V152.966L69.8438 145.285Z",
    fill: "#875532",
    fillOpacity: 0.5
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M272.215 126.725L135.943 80.0391L62.7129 130.748L198.12 180.319L272.215 126.725Z",
    fill: "url(#paint4_linear_1415_3219)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M233.223 164.225L262.176 156.527V160.684L233.223 168.765V164.225Z",
    fill: "#190C15"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M272.215 146.498L301.169 138.801V142.957L272.215 151.039V146.498Z",
    fill: "#190C15"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M248.749 144.852L266.904 140.027L267.483 144.026L239.174 151.928L248.749 144.852Z",
    fill: "#190C15"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M206.375 260.561L327.893 225.041V223.07L206.375 258.175V260.561Z",
    fill: "#030511"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M272.215 126.725L332.743 144.92L194.671 96.9708L135.943 80.0391L272.215 126.725Z",
    fill: "#454E79"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M187.316 85.5781V97.6381L199.19 100.703V82.6914L187.316 85.5781Z",
    fill: "#010510"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M187.317 85.5771L176.922 81.8828V94.0756L187.317 97.637V85.5771Z",
    fill: "#02030D"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M187.316 85.6804C187.304 85.6804 187.293 85.6804 187.281 85.6742L176.886 81.98C176.843 81.9657 176.816 81.9227 176.818 81.8778C176.821 81.8328 176.853 81.7939 176.898 81.7837L188.95 78.9747C188.95 78.9747 188.967 78.9727 188.973 78.9727C188.985 78.9727 188.995 78.9727 189.008 78.9788L199.225 82.5953C199.268 82.6097 199.294 82.6526 199.292 82.6976C199.29 82.7425 199.257 82.7814 199.214 82.7916L187.34 85.6783C187.34 85.6783 187.324 85.6804 187.316 85.6804Z",
    fill: "#4C4D69"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M188.972 79.0755L199.189 82.6921L187.315 85.5788L176.92 81.8845L188.972 79.0755ZM188.972 78.8711C188.955 78.8711 188.941 78.8711 188.925 78.8772L176.873 81.6862C176.785 81.7067 176.719 81.7823 176.715 81.8743C176.711 81.9643 176.766 82.0481 176.85 82.0788L187.245 85.773C187.268 85.7812 187.29 85.7853 187.313 85.7853C187.329 85.7853 187.345 85.7853 187.362 85.7791L199.236 82.8924C199.324 82.872 199.387 82.7943 199.391 82.7044C199.395 82.6144 199.34 82.5306 199.256 82.502L189.039 78.8854C189.017 78.8772 188.994 78.8731 188.972 78.8731V78.8711Z",
    fill: "#141730"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M180.041 82.3281L187.317 84.6935",
    stroke: "#B2B6D1",
    strokeWidth: 1.45465,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M189.203 79.459L198.289 82.6053",
    stroke: "#B2B6D1",
    strokeWidth: 1.45465,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M180.588 82.1723L188.645 80.2383L195.835 82.6057L187.635 84.5683L180.588 82.1723Z",
    fill: "#020206"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M272.215 126.726L202.043 102.686L287.704 131.383L272.215 126.726Z",
    fill: "url(#paint5_linear_1415_3219)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8426 204.752L50.3594 209.957L201.06 269.86L352.61 225.043L327.892 215.863V217.161L349.143 225.141L201.06 268.758L53.266 209.975L69.8426 205.531V204.752Z",
    fill: "#3A4173"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M202.758 261.603L201.062 268.757L349.145 225.139L327.895 217.16V223.071V225.041L202.758 261.603Z",
    fill: "#0D1329"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M327.893 217.161V215.863L352.611 225.043L318.963 234.993L324.911 232.28L349.144 225.141L327.893 217.161Z",
    fill: "url(#paint6_linear_1415_3219)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8442 205.529L53.2676 209.974L201.062 268.757L202.758 261.603L69.8442 207.954V205.529Z",
    fill: "#040719"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1558 218.678L11.4531 241.031L39.0017 254.134L123.355 230.505L93.1558 218.678Z",
    fill: "url(#paint7_linear_1415_3219)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9961 254.133V255.288L110.848 234.748L110.854 234.004L38.9961 254.133Z",
    fill: "url(#paint8_linear_1415_3219)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M110.862 234.006L110.854 234.75L201.485 270.991L352.611 226.139V225.043L201.061 269.86L110.862 234.006Z",
    fill: "#32355F"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M86.35 210.68L0 176.861L22.5842 170.92V171.666L2.57117 176.943L85.2721 209.332L86.35 210.68Z",
    fill: "url(#paint9_linear_1415_3219)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5853 171.668L2.57227 176.945L69.8141 203.444L69.905 196.171L22.5853 177.746V171.668Z",
    fill: "#090F1F"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M0 176.861V178.319L69.843 205.53V204.215L0 176.861Z",
    fill: "#42466D"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9726 124.124L18.3359 104.486V102.01L74.509 122.576L71.9726 124.124Z",
    fill: "#030511"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M74.509 122.576L18.3359 102.01L77.5673 73.25L124.843 82.1597L131.389 84.1598L74.509 122.576Z",
    fill: "#030511"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M120.844 88.5238L100.297 81.0687L77.75 73.25L124.48 81.9779L131.39 84.3417L120.844 88.5238Z",
    fill: "url(#paint10_linear_1415_3219)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M22.584 177.744V106.043L30.277 108.858V180.754L22.584 177.744Z",
    fill: "#E7DBD5"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8424 193.783L40.0049 182.115L36.1328 183.043L69.8424 196.226V193.783Z",
    fill: "#283468"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0059 182.201V121.223L64.1282 129.854L62.7128 130.833L63.4675 132.549L69.8433 134.883V193.881L40.0059 182.201Z",
    fill: "#DFCCC5"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0859 127.545L59.5068 133.261V138.744L44.0859 132.991V127.545Z",
    fill: "#352D42"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1738 128.318V132.336L59.5042 137.242V133.26L46.1738 128.318Z",
    fill: "#977044"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1756 128.321L44.9688 127.873V132.784L59.506 138.138V137.245L46.1756 132.338V128.321Z",
    fill: "#483B3E"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M69.844 137.243L66.5508 135.992V141.073L69.844 142.361V137.243Z",
    fill: "#352D42"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M68.543 136.748V140.61L69.8439 141.109V137.243L68.543 136.748Z",
    fill: "#8E604C"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2812 136.268V140.745L69.8442 141.745V141.109L68.5433 140.61V136.748L67.2812 136.268Z",
    fill: "#312832"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1328 120.021L40.0049 121.224V182.202L36.1328 183.044V120.021Z",
    fill: "#B0A0AB"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9725 124.125L30.2773 108.857V180.753L36.1336 183.043V120.02L64.128 129.853L71.9725 124.125Z",
    fill: "#DACDCB"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M249.873 200.305L252.164 201.282L262.653 198.498L260.362 197.762L249.873 200.305Z",
    fill: "#1E1E21"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M262.657 198.498L252.168 201.283V220.091L262.657 217.208V198.498Z",
    fill: "url(#paint11_linear_1415_3219)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M249.873 200.305L252.164 201.282V220.09L249.941 219.162L249.873 200.305Z",
    fill: "#17181A"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M245.739 127.134L193.131 165.853V163.929L244.417 126.723L245.739 127.134Z",
    fill: "#050510"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M244.417 126.723L137.809 90.1387L244.724 126.37L245.738 127.134L244.417 126.723Z",
    fill: "#4E5267"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M193.133 163.93V165.854L82.4883 127.241L84.6831 126.209L193.133 163.93Z",
    fill: "#050510"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M137.631 91.0801L85.627 125.992L195.271 163.994L242.547 126.173L137.631 91.0801Z",
    fill: "#343456"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0449 126.267L137.172 90.1973L243.781 126.784L192.494 163.988L84.0449 126.267Z",
    fill: "url(#paint12_linear_1415_3219)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M219.364 118.809L169.906 154.811",
    stroke: "#49517D",
    strokeWidth: 0.363661,
    strokeLinecap: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M198.18 111.627L148.812 147.357",
    stroke: "#49517D",
    strokeWidth: 0.363661,
    strokeLinecap: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M177.633 104.717L128.539 140.174",
    stroke: "#49517D",
    strokeWidth: 0.363661,
    strokeLinecap: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M157.086 98.0781L108.355 132.99",
    stroke: "#49517D",
    strokeWidth: 0.363661,
    strokeLinecap: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M114.174 107.445L220.181 143.811",
    stroke: "#919196",
    strokeWidth: 0.363661,
    strokeLinecap: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M194.916 163.992L242.555 126.172L137.457 90.8965",
    stroke: "url(#paint13_linear_1415_3219)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M195.005 163.993L86.1797 125.808L137.449 90.9883",
    stroke: "url(#paint14_linear_1415_3219)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0219 147.915V152.648C26.0219 152.648 28.2106 147.547 28.2269 139.75C28.2433 131.785 24.7148 134.647 24.7148 134.647",
    stroke: "url(#paint15_linear_1415_3219)",
    strokeWidth: 2.90929,
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7129 134.649V144.364C24.7129 144.526 24.8274 144.663 24.9849 144.695L27.1716 145.636C27.552 145.711 27.9079 145.419 27.9079 145.03V135.714C27.9079 135.422 27.6972 135.17 27.4109 135.119L25.2304 134.269C24.9624 134.22 24.7149 134.375 24.7149 134.649H24.7129Z",
    fill: "url(#paint16_linear_1415_3219)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9779 148.306C25.7713 148.306 25.6035 148.157 25.6035 147.971C25.6035 147.971 24.9776 145.92 25.2722 145.362C25.5667 144.804 25.7713 145.202 25.9758 145.202C26.1824 145.202 26.8451 145.286 26.8451 145.472L26.3501 147.971C26.3501 148.155 26.1824 148.306 25.9758 148.306H25.9779Z",
    fill: "url(#paint17_linear_1415_3219)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1367 134.939V144.654C24.1367 144.815 24.2513 144.952 24.4088 144.985L26.5954 145.925C26.9758 146.001 27.3318 145.709 27.3318 145.32V136.004C27.3318 135.711 27.1211 135.46 26.8347 135.409L24.6542 134.507C24.3863 134.458 24.1388 134.665 24.1388 134.939H24.1367Z",
    fill: "url(#paint18_linear_1415_3219)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1367 134.939V142.756C24.1367 142.918 24.2513 143.055 24.4088 143.088L26.5954 144.028C26.9758 144.104 27.3318 143.811 27.3318 143.423V136.004C27.3318 135.711 27.1211 135.46 26.8347 135.409L24.6542 134.507C24.3863 134.458 24.1388 134.665 24.1388 134.939H24.1367Z",
    fill: "url(#paint19_linear_1415_3219)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4082 144.982C24.4082 146.851 27.1287 153.367 27.908 145.029",
    stroke: "url(#paint20_linear_1415_3219)",
    strokeWidth: 2.90929,
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M250.91 210.725L241.27 213.308",
    stroke: "#00F076",
    strokeWidth: 1.45465,
    strokeLinecap: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M256.713 218.896V271.264H383.769V248.368",
    stroke: "url(#paint21_linear_1415_3219)",
    strokeWidth: 0.727323,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M256.713 219.014V271.264H383.662V248.368",
    stroke: "url(#paint22_linear_1415_3219)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M256.264 198.93L256.264 138.538L235.824 131.992",
    stroke: "#00F076",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M241.909 194.223L224.119 198.945V230.842L241.909 225.956V194.223Z",
    fill: "url(#paint23_linear_1415_3219)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M220.234 197.291L224.121 198.947V230.844L220.347 229.272L220.234 197.291Z",
    fill: "#17181A"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M220.234 197.29L224.121 198.946L241.91 194.224L238.024 192.977L220.234 197.29Z",
    fill: "#1E1E21"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M220.828 200.605L223.514 201.724V229.887L220.941 228.853L220.828 200.605Z",
    fill: "#06E775"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-offer-review-house-sunrun-labels": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.219 20.1629C144.225 20.1629 141.904 18.493 141.904 15.8252C141.904 14.1552 142.922 12.913 144.307 12.3224C143.288 11.7114 142.515 10.6728 142.515 9.41018C142.515 7.17002 144.449 5.58155 147.219 5.58155C149.989 5.58155 151.923 7.17002 151.923 9.41018C151.923 10.6728 151.149 11.7114 150.07 12.3224C151.516 12.913 152.514 14.1552 152.514 15.8252C152.514 18.493 150.192 20.1629 147.219 20.1629ZM144.531 15.7641C144.531 17.0674 145.59 17.8413 147.219 17.8413C148.828 17.8413 149.866 17.0674 149.866 15.7641C149.866 14.4811 148.828 13.6665 147.219 13.6665C145.59 13.6665 144.531 14.4811 144.531 15.7641ZM145.019 9.512C145.019 10.5914 145.875 11.2634 147.219 11.2634C148.543 11.2634 149.398 10.5914 149.398 9.512C149.398 8.43266 148.543 7.76061 147.219 7.76061C145.875 7.76061 145.019 8.43266 145.019 9.512ZM159.024 20.1629C155.48 20.1629 153.851 17.7191 153.851 13.361V12.3835C153.851 8.02536 155.48 5.58155 159.024 5.58155H159.818C163.382 5.58155 164.991 8.02536 164.991 12.3835V13.361C164.991 17.7191 163.382 20.1629 159.818 20.1629H159.024ZM156.539 14.0738C156.539 16.5787 157.537 17.8209 159.146 17.8209H159.716C161.325 17.8209 162.302 16.5787 162.302 14.0738V11.6707C162.302 9.14543 161.325 7.90317 159.716 7.90317H159.146C157.537 7.90317 156.539 9.14543 156.539 11.6707V14.0738ZM166.468 20L176.814 5.74447H179.033L168.688 20H166.468ZM166.102 8.83996C166.102 7.0071 167.385 5.58155 169.217 5.58155C171.05 5.58155 172.313 7.0071 172.313 8.83996C172.313 10.6728 171.05 12.0984 169.217 12.0984C167.385 12.0984 166.102 10.6728 166.102 8.83996ZM167.873 8.83996C167.873 9.77675 168.403 10.4692 169.217 10.4692C170.032 10.4692 170.582 9.77675 170.582 8.83996C170.582 7.90317 170.032 7.21075 169.217 7.21075C168.403 7.21075 167.873 7.90317 167.873 8.83996ZM173.189 16.9045C173.189 15.0717 174.472 13.6461 176.304 13.6461C178.137 13.6461 179.4 15.0717 179.4 16.9045C179.4 18.7374 178.137 20.1629 176.304 20.1629C174.472 20.1629 173.189 18.7374 173.189 16.9045ZM174.96 16.9045C174.96 17.8413 175.49 18.5337 176.304 18.5337C177.119 18.5337 177.669 17.8413 177.669 16.9045C177.669 15.9677 177.119 15.2753 176.304 15.2753C175.49 15.2753 174.96 15.9677 174.96 16.9045Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.61 37.1415C144.45 37.1415 143.511 36.8453 142.792 36.2527C142.074 35.6476 141.689 34.8344 141.639 33.8133H143.757C143.807 34.2671 143.996 34.6264 144.324 34.8912C144.665 35.1559 145.093 35.2883 145.61 35.2883C146.051 35.2883 146.411 35.1937 146.688 35.0046C146.965 34.8029 147.104 34.5571 147.104 34.2671C147.104 33.9898 147.016 33.7755 146.839 33.6242C146.675 33.4603 146.461 33.3468 146.196 33.2838C145.944 33.2082 145.585 33.1262 145.118 33.038C144.438 32.9119 143.883 32.7732 143.454 32.6219C143.038 32.4706 142.673 32.1996 142.357 31.8088C142.055 31.418 141.904 30.8633 141.904 30.1447C141.904 29.6026 142.049 29.1172 142.339 28.6886C142.641 28.2473 143.051 27.9069 143.568 27.6674C144.085 27.4279 144.665 27.3081 145.307 27.3081C146.429 27.3081 147.344 27.5918 148.049 28.1591C148.755 28.7138 149.134 29.4576 149.184 30.3905H147.047C146.997 29.9745 146.801 29.6467 146.461 29.4072C146.133 29.1676 145.768 29.0479 145.364 29.0479C144.948 29.0479 144.614 29.1424 144.362 29.3315C144.122 29.508 144.003 29.7539 144.003 30.069C144.003 30.4472 144.154 30.7057 144.457 30.8444C144.772 30.9704 145.263 31.0776 145.932 31.1658C146.625 31.2667 147.192 31.3928 147.633 31.544C148.087 31.6827 148.472 31.9601 148.787 32.3761C149.115 32.7795 149.279 33.3783 149.279 34.1726C149.279 35.0677 148.945 35.7863 148.276 36.3284C147.608 36.8705 146.719 37.1415 145.61 37.1415ZM159.43 36.9902H157.123V35.5152C156.858 36.0321 156.468 36.4355 155.951 36.7255C155.434 37.0028 154.835 37.1415 154.154 37.1415C153.083 37.1415 152.219 36.7948 151.563 36.1014C150.92 35.3955 150.599 34.4815 150.599 33.3594V27.4594H152.925V32.8678C152.925 33.5233 153.108 34.0591 153.473 34.4752C153.839 34.8786 154.318 35.0803 154.911 35.0803C155.566 35.0803 156.096 34.8534 156.499 34.3995C156.915 33.9457 157.123 33.3657 157.123 32.6598V27.4594H159.43V36.9902ZM161.415 27.4594H163.741V28.9344C163.993 28.4175 164.377 28.0204 164.894 27.7431C165.424 27.4531 166.029 27.3081 166.709 27.3081C167.415 27.3081 168.033 27.472 168.563 27.7998C169.105 28.115 169.521 28.5562 169.811 29.1235C170.101 29.6908 170.246 30.3464 170.246 31.0902V36.9902H167.939V31.5819C167.939 30.9263 167.75 30.3968 167.371 29.9934C167.006 29.5774 166.527 29.3693 165.934 29.3693C165.291 29.3693 164.762 29.5963 164.346 30.0501C163.942 30.504 163.741 31.0839 163.741 31.7899V36.9902H161.415V27.4594ZM176.504 29.4072C175.785 29.4072 175.262 29.6845 174.934 30.2392C174.607 30.7813 174.443 31.5314 174.443 32.4896V36.9902H172.117V27.4594H174.443V29.1424C174.682 28.5373 174.991 28.1087 175.369 27.8565C175.76 27.5918 176.264 27.4594 176.882 27.4594H177.998V29.4072H176.504ZM187.732 36.9902H185.425V35.5152C185.16 36.0321 184.77 36.4355 184.253 36.7255C183.736 37.0028 183.137 37.1415 182.456 37.1415C181.385 37.1415 180.521 36.7948 179.865 36.1014C179.223 35.3955 178.901 34.4815 178.901 33.3594V27.4594H181.227V32.8678C181.227 33.5233 181.41 34.0591 181.775 34.4752C182.141 34.8786 182.62 35.0803 183.213 35.0803C183.868 35.0803 184.398 34.8534 184.801 34.3995C185.217 33.9457 185.425 33.3657 185.425 32.6598V27.4594H187.732V36.9902ZM189.717 27.4594H192.043V28.9344C192.295 28.4175 192.679 28.0204 193.196 27.7431C193.726 27.4531 194.331 27.3081 195.012 27.3081C195.718 27.3081 196.335 27.472 196.865 27.7998C197.407 28.115 197.823 28.5562 198.113 29.1235C198.403 29.6908 198.548 30.3464 198.548 31.0902V36.9902H196.241V31.5819C196.241 30.9263 196.052 30.3968 195.673 29.9934C195.308 29.5774 194.829 29.3693 194.236 29.3693C193.593 29.3693 193.064 29.5963 192.648 30.0501C192.244 30.504 192.043 31.0839 192.043 31.7899V36.9902H189.717V27.4594Z",
    fill: "black"
  }))), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    "data-offer-review-house-green-line": "true",
    d: "M137.457 6.29492L137.457 90.8972",
    stroke: "#20AC87",
    strokeWidth: 1.5
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-offer-review-house-labels": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M362.267 74.3748C362.206 71.2182 364.181 69.2632 367.297 69.2632C370.25 69.2632 372.286 71.0146 372.286 73.6824C372.286 75.5967 371.146 77.1241 368.886 78.2442L366.706 79.3439C365.871 79.7716 364.894 80.464 364.894 81.3397H372.266V83.6816H362.267L362.247 81.7062C362.226 79.405 364.161 77.898 365.525 77.2259L367.806 76.0855C368.987 75.5153 369.578 74.7007 369.578 73.662C369.578 72.3383 368.682 71.483 367.297 71.483C365.79 71.483 364.914 72.6438 364.975 74.3748H362.267ZM378.926 83.8446C375.383 83.8446 373.753 81.4008 373.753 77.0426V76.0651C373.753 71.707 375.383 69.2632 378.926 69.2632H379.72C383.284 69.2632 384.893 71.707 384.893 76.0651V77.0426C384.893 81.4008 383.284 83.8446 379.72 83.8446H378.926ZM376.442 77.7554C376.442 80.2603 377.439 81.5026 379.048 81.5026H379.619C381.227 81.5026 382.205 80.2603 382.205 77.7554V75.3523C382.205 72.8271 381.227 71.5848 379.619 71.5848H379.048C377.439 71.5848 376.442 72.8271 376.442 75.3523V77.7554ZM386.371 83.6816L396.716 69.4261H398.936L388.59 83.6816H386.371ZM386.004 72.5216C386.004 70.6887 387.287 69.2632 389.12 69.2632C390.953 69.2632 392.215 70.6887 392.215 72.5216C392.215 74.3545 390.953 75.78 389.12 75.78C387.287 75.78 386.004 74.3545 386.004 72.5216ZM387.776 72.5216C387.776 73.4584 388.305 74.1508 389.12 74.1508C389.935 74.1508 390.484 73.4584 390.484 72.5216C390.484 71.5848 389.935 70.8924 389.12 70.8924C388.305 70.8924 387.776 71.5848 387.776 72.5216ZM393.091 80.5862C393.091 78.7533 394.374 77.3277 396.207 77.3277C398.04 77.3277 399.302 78.7533 399.302 80.5862C399.302 82.419 398.04 83.8446 396.207 83.8446C394.374 83.8446 393.091 82.419 393.091 80.5862ZM394.863 80.5862C394.863 81.5229 395.392 82.2154 396.207 82.2154C397.022 82.2154 397.571 81.5229 397.571 80.5862C397.571 79.6494 397.022 78.957 396.207 78.957C395.392 78.957 394.863 79.6494 394.863 80.5862Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.22 91.141V100.672H368.913V99.1969C368.384 100.237 367.306 100.823 365.944 100.823C363.788 100.823 362.389 99.2725 362.389 97.0411V91.141H364.715V96.5494C364.715 97.8542 365.509 98.7619 366.701 98.7619C368.005 98.7619 368.913 97.7408 368.913 96.3414V91.141H371.22ZM374.112 88.2667H376.438V91.141H379.086V93.0888H376.438V97.2491C376.438 98.2135 376.949 98.7052 377.819 98.7052H379.086V100.672H377.554C375.474 100.672 374.112 99.4616 374.112 97.3436V93.0888H372.24V91.141H374.112V88.2667ZM380.361 100.672V91.141H382.687V100.672H380.361ZM380.285 89.6471V87.0564H382.782V89.6471H380.285ZM384.655 100.672V87.0564H386.981V100.672H384.655ZM388.949 100.672V91.141H391.275V100.672H388.949ZM388.873 89.6471V87.0564H391.37V89.6471H388.873ZM394.151 88.2667H396.477V91.141H399.124V93.0888H396.477V97.2491C396.477 98.2135 396.987 98.7052 397.857 98.7052H399.124V100.672H397.592C395.512 100.672 394.151 99.4616 394.151 97.3436V93.0888H392.279V91.141H394.151V88.2667ZM401.516 104.53L402.878 100.653L399.398 91.141H401.762L403.955 97.684L406.149 91.141H408.532L405.62 99.1212L403.729 104.53H401.516Z",
    fill: "black"
  }))), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M378.977 244.452L383.489 246.006V117.499L378.977 115.945V244.452Z",
    fill: "url(#paint24_linear_1415_3219)",
    stroke: "#0B0B18",
    strokeWidth: 0.418393,
    strokeLinejoin: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M383.49 246.008L388.122 244.753V116.246L383.49 117.501V246.008Z",
    fill: "url(#paint25_linear_1415_3219)",
    stroke: "#0B0B18",
    strokeWidth: 0.418393,
    strokeLinejoin: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M378.977 115.947L383.489 117.501L388.121 116.245L383.609 114.691L378.977 115.947Z",
    fill: "#D9AA76",
    stroke: "#0B0B18",
    strokeWidth: 0.418393,
    strokeLinejoin: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M378.408 115.916L383.489 117.679V116.484L378.408 114.721V115.916Z",
    fill: "#2A2336",
    stroke: "#0B0B18",
    strokeWidth: 0.358623,
    strokeLinejoin: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M383.49 117.68L388.69 116.275V115.08L383.49 116.485V117.68Z",
    fill: "#1A1628",
    stroke: "#0B0B18",
    strokeWidth: 0.358623,
    strokeLinejoin: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M378.408 114.721L383.489 116.484L388.689 115.08L383.608 113.316L378.408 114.721Z",
    fill: "#3A2F3A",
    stroke: "#0B0B18",
    strokeWidth: 0.358623,
    strokeLinejoin: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M379.965 234.323V133.609",
    stroke: "#8D5F3B",
    strokeWidth: 0.268967
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M381.1 237.401V137.584",
    stroke: "#8D5F3B",
    strokeWidth: 0.268967
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M382.234 230.616V128.707",
    stroke: "#8D5F3B",
    strokeWidth: 0.268967
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M378.977 244.454L383.489 246.008V238.238L378.977 236.684V244.454Z",
    fill: "#7A5233",
    stroke: "#0B0B18",
    strokeWidth: 0.418393,
    strokeLinejoin: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M383.49 246.008L388.122 244.753V236.982L383.49 238.238V246.008Z",
    fill: "#4C3120",
    stroke: "#0B0B18",
    strokeWidth: 0.418393,
    strokeLinejoin: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M384.953 209.756L386.926 210.443",
    stroke: "#15172C",
    strokeWidth: 0.657475,
    strokeLinecap: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M386.688 201.508L387.996 201.982",
    stroke: "#15172C",
    strokeWidth: 0.657475,
    strokeLinecap: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M384.953 194.217L386.926 194.904",
    stroke: "#15172C",
    strokeWidth: 0.657475,
    strokeLinecap: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M386.688 185.969L387.996 186.451",
    stroke: "#15172C",
    strokeWidth: 0.657475,
    strokeLinecap: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M384.953 178.676L386.926 179.363",
    stroke: "#15172C",
    strokeWidth: 0.657475,
    strokeLinecap: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M386.688 170.428L387.996 170.92",
    stroke: "#15172C",
    strokeWidth: 0.657475,
    strokeLinecap: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M384.953 163.135L386.926 163.822",
    stroke: "#15172C",
    strokeWidth: 0.657475,
    strokeLinecap: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M386.688 154.887L387.965 155.42",
    stroke: "#15172C",
    strokeWidth: 0.657475,
    strokeLinecap: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M384.953 147.596L386.926 148.283",
    stroke: "#15172C",
    strokeWidth: 0.657475,
    strokeLinecap: "round"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M386.688 139.346L387.934 139.826",
    stroke: "#15172C",
    strokeWidth: 0.657475,
    strokeLinecap: "round"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M379.545 200.164L381.786 200.942V195.562L379.545 194.785V200.164Z",
    fill: "#ECEAEE",
    stroke: "#0B0B18",
    strokeWidth: 0.328737,
    strokeLinejoin: "round"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M381.785 200.941L382.383 200.791V195.412L381.785 195.562V200.941Z",
    fill: "#9C98A4",
    stroke: "#0B0B18",
    strokeWidth: 0.328737,
    strokeLinejoin: "round"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M379.545 194.784L381.786 195.561L382.384 195.412L380.113 194.635L379.545 194.784Z",
    fill: "white",
    stroke: "#0B0B18",
    strokeWidth: 0.328737,
    strokeLinejoin: "round"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M381.249 134.057L368.488 120.938",
    stroke: "#262842",
    strokeWidth: 0.597705,
    strokeLinecap: "round"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M381.25 134.057L392.248 129.096",
    stroke: "#262842",
    strokeWidth: 0.597705,
    strokeLinecap: "round"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M354.322 117.442L401.81 133.819V130.531L354.322 114.154V117.442Z",
    fill: "url(#paint26_linear_1415_3219)",
    stroke: "#0B0B18",
    strokeWidth: 0.418393,
    strokeLinejoin: "round"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M401.809 133.816L404.976 132.979V129.691L401.809 130.528V133.816Z",
    fill: "#6E4A2E",
    stroke: "#0B0B18",
    strokeWidth: 0.418393,
    strokeLinejoin: "round"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M354.322 114.153L401.81 130.53L404.978 129.694L357.49 113.316L354.322 114.153Z",
    fill: "#DCAE7C",
    stroke: "#0B0B18",
    strokeWidth: 0.418393,
    strokeLinejoin: "round"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M361.734 113.676H360.539V115.469H361.734V113.676Z",
    fill: "#2A2C48",
    stroke: "#0B0B18",
    strokeWidth: 0.239082
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M363.076 112.777H359.191V113.674H363.076V112.777Z",
    fill: "url(#paint27_linear_1415_3219)",
    stroke: "#0B0B18",
    strokeWidth: 0.239082
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M361.134 113.408C362.207 113.408 363.076 113.127 363.076 112.78C363.076 112.433 362.207 112.152 361.134 112.152C360.061 112.152 359.191 112.433 359.191 112.78C359.191 113.127 360.061 113.408 361.134 113.408Z",
    fill: "#B9BEDB",
    stroke: "#0B0B18",
    strokeWidth: 0.239082
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M362.78 111.584H359.492V112.481H362.78V111.584Z",
    fill: "url(#paint28_linear_1415_3219)",
    stroke: "#0B0B18",
    strokeWidth: 0.239082
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M361.136 112.121C362.044 112.121 362.78 111.88 362.78 111.583C362.78 111.286 362.044 111.045 361.136 111.045C360.228 111.045 359.492 111.286 359.492 111.583C359.492 111.88 360.228 112.121 361.136 112.121Z",
    fill: "#B9BEDB",
    stroke: "#0B0B18",
    strokeWidth: 0.239082
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M362.481 110.389H359.791V111.285H362.481V110.389Z",
    fill: "url(#paint29_linear_1415_3219)",
    stroke: "#0B0B18",
    strokeWidth: 0.239082
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M361.136 110.806C361.879 110.806 362.481 110.618 362.481 110.387C362.481 110.156 361.879 109.969 361.136 109.969C360.393 109.969 359.791 110.156 359.791 110.387C359.791 110.618 360.393 110.806 361.136 110.806Z",
    fill: "#B9BEDB",
    stroke: "#0B0B18",
    strokeWidth: 0.239082
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M371.924 117.172H370.729V118.965H371.924V117.172Z",
    fill: "#2A2C48",
    stroke: "#0B0B18",
    strokeWidth: 0.239082
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M373.27 116.275H369.385V117.172H373.27V116.275Z",
    fill: "url(#paint30_linear_1415_3219)",
    stroke: "#0B0B18",
    strokeWidth: 0.239082
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M371.327 116.904C372.4 116.904 373.27 116.623 373.27 116.276C373.27 115.929 372.4 115.648 371.327 115.648C370.254 115.648 369.385 115.929 369.385 116.276C369.385 116.623 370.254 116.904 371.327 116.904Z",
    fill: "#B9BEDB",
    stroke: "#0B0B18",
    strokeWidth: 0.239082
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M372.969 115.08H369.682V115.977H372.969V115.08Z",
    fill: "url(#paint31_linear_1415_3219)",
    stroke: "#0B0B18",
    strokeWidth: 0.239082
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M371.325 115.619C372.233 115.619 372.969 115.378 372.969 115.081C372.969 114.784 372.233 114.543 371.325 114.543C370.418 114.543 369.682 114.784 369.682 115.081C369.682 115.378 370.418 115.619 371.325 115.619Z",
    fill: "#B9BEDB",
    stroke: "#0B0B18",
    strokeWidth: 0.239082
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M372.672 113.885H369.982V114.781H372.672V113.885Z",
    fill: "url(#paint32_linear_1415_3219)",
    stroke: "#0B0B18",
    strokeWidth: 0.239082
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M371.327 114.304C372.07 114.304 372.672 114.116 372.672 113.885C372.672 113.654 372.07 113.467 371.327 113.467C370.585 113.467 369.982 113.654 369.982 113.885C369.982 114.116 370.585 114.304 371.327 114.304Z",
    fill: "#B9BEDB",
    stroke: "#0B0B18",
    strokeWidth: 0.239082
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M399.061 126.525H397.865V128.319H399.061V126.525Z",
    fill: "#2A2C48",
    stroke: "#0B0B18",
    strokeWidth: 0.239082
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M400.407 125.629H396.521V126.525H400.407V125.629Z",
    fill: "url(#paint33_linear_1415_3219)",
    stroke: "#0B0B18",
    strokeWidth: 0.239082
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M398.464 126.257C399.537 126.257 400.407 125.976 400.407 125.63C400.407 125.283 399.537 125.002 398.464 125.002C397.391 125.002 396.521 125.283 396.521 125.63C396.521 125.976 397.391 126.257 398.464 126.257Z",
    fill: "#B9BEDB",
    stroke: "#0B0B18",
    strokeWidth: 0.239082
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M400.106 124.434H396.818V125.33H400.106V124.434Z",
    fill: "url(#paint34_linear_1415_3219)",
    stroke: "#0B0B18",
    strokeWidth: 0.239082
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M398.462 124.972C399.37 124.972 400.106 124.732 400.106 124.434C400.106 124.137 399.37 123.896 398.462 123.896C397.554 123.896 396.818 124.137 396.818 124.434C396.818 124.732 397.554 124.972 398.462 124.972Z",
    fill: "#B9BEDB",
    stroke: "#0B0B18",
    strokeWidth: 0.239082
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M399.809 123.238H397.119V124.135H399.809V123.238Z",
    fill: "url(#paint35_linear_1415_3219)",
    stroke: "#0B0B18",
    strokeWidth: 0.239082
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M398.464 123.657C399.207 123.657 399.809 123.47 399.809 123.239C399.809 123.008 399.207 122.82 398.464 122.82C397.721 122.82 397.119 123.008 397.119 123.239C397.119 123.47 397.721 123.657 398.464 123.657Z",
    fill: "#B9BEDB",
    stroke: "#0B0B18",
    strokeWidth: 0.239082
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M375.213 158.712L378.022 159.668V150.702L375.213 149.746V158.712Z",
    fill: "#23253F",
    stroke: "#0B0B18",
    strokeWidth: 0.328737,
    strokeLinejoin: "round"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M378.021 159.669L382.654 158.444V149.479L378.021 150.704V159.669Z",
    fill: "#15172C",
    stroke: "#0B0B18",
    strokeWidth: 0.328737,
    strokeLinejoin: "round"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M375.213 149.745L378.022 150.702L382.654 149.476L379.815 148.49L375.213 149.745Z",
    fill: "#3A3C5C",
    stroke: "#0B0B18",
    strokeWidth: 0.328737,
    strokeLinejoin: "round"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M368.039 146.07V165.795C368.039 166.31 368.7 166.804 369.877 167.168C371.054 167.532 372.65 167.737 374.315 167.737C375.979 167.737 377.576 167.532 378.753 167.168C379.93 166.804 380.591 166.31 380.591 165.795V146.07H368.039Z",
    fill: "url(#paint36_linear_1415_3219)",
    stroke: "#0B0B18",
    strokeWidth: 0.418393
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M368.039 161.912C368.039 162.427 368.7 162.921 369.877 163.286C371.054 163.65 372.65 163.855 374.315 163.855C375.979 163.855 377.576 163.65 378.753 163.286C379.93 162.921 380.591 162.427 380.591 161.912",
    stroke: "#8D8996",
    strokeWidth: 0.358623
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M368.039 149.957C368.039 150.472 368.7 150.966 369.877 151.331C371.054 151.695 372.65 151.9 374.315 151.9C375.979 151.9 377.576 151.695 378.753 151.331C379.93 150.966 380.591 150.472 380.591 149.957",
    stroke: "#8D8996",
    strokeWidth: 0.358623
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M374.318 148.254C378.032 148.254 381.042 147.277 381.042 146.072C381.042 144.867 378.032 143.891 374.318 143.891C370.604 143.891 367.594 144.867 367.594 146.072C367.594 147.277 370.604 148.254 374.318 148.254Z",
    fill: "url(#paint37_linear_1415_3219)",
    stroke: "#0B0B18",
    strokeWidth: 0.418393
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M374.317 146.461C376.793 146.461 378.8 145.885 378.8 145.176C378.8 144.466 376.793 143.891 374.317 143.891C371.841 143.891 369.834 144.466 369.834 145.176C369.834 145.885 371.841 146.461 374.317 146.461Z",
    fill: "#241C34",
    stroke: "#0B0B18",
    strokeWidth: 0.298852
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M373.717 150.256H371.027C370.862 150.256 370.729 150.39 370.729 150.555V152.348C370.729 152.513 370.862 152.647 371.027 152.647H373.717C373.882 152.647 374.016 152.513 374.016 152.348V150.555C374.016 150.39 373.882 150.256 373.717 150.256Z",
    fill: "#E2B25E",
    stroke: "#0B0B18",
    strokeWidth: 0.268967
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M372.223 142.754H370.729V145.444H372.223V142.754Z",
    fill: "url(#paint38_linear_1415_3219)",
    stroke: "#0B0B18",
    strokeWidth: 0.239082
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M377.902 144.008H376.408V146.697H377.902V144.008Z",
    fill: "url(#paint39_linear_1415_3219)",
    stroke: "#0B0B18",
    strokeWidth: 0.239082
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M371.477 142.752C370.68 134.324 370.631 125.896 371.328 117.469",
    stroke: "#14162E",
    strokeWidth: 0.448278
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M377.156 144.008C380.742 140.263 387.845 134.535 398.464 126.824",
    stroke: "#14162E",
    strokeWidth: 0.448278
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1415_3219",
    x1: 97.2168,
    y1: 190.258,
    x2: 104.253,
    y2: 190.258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#030511"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20130C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1415_3219",
    x1: 143.517,
    y1: 197.417,
    x2: 149.512,
    y2: 197.417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#030511"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20130C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1415_3219",
    x1: -9.16665,
    y1: 222.76,
    x2: 118.073,
    y2: 222.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#030511"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20130C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1415_3219",
    x1: 144.057,
    y1: 223.27,
    x2: 187.996,
    y2: 223.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#030511"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20130C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1415_3219",
    x1: 62.7129,
    y1: 130.178,
    x2: 272.215,
    y2: 130.178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.139779,
    stopColor: "#39252D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.962564,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1415_3219",
    x1: 230.248,
    y1: 114.371,
    x2: 314.519,
    y2: 129.726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2B6D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2B6D1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1415_3219",
    x1: 319.609,
    y1: 227.69,
    x2: 332.339,
    y2: 223.223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8BCDF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#B8BCDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1415_3219",
    x1: 37.4482,
    y1: 282.054,
    x2: 83.487,
    y2: 193.974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B8BCDF",
    stopOpacity: 0.721569
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.514423,
    stopColor: "#B8B2BA",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.739173,
    stopColor: "#B8B2BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1415_3219",
    x1: 39.9425,
    y1: 255.288,
    x2: 109.901,
    y2: 234.004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0224732,
    stopColor: "#2B2D4F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.551818,
    stopColor: "#2B2D4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2D4F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1415_3219",
    x1: 14.2222,
    y1: 175.281,
    x2: 31.6668,
    y2: 183.572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A8CB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#8486AE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1415_3219",
    x1: 18.3368,
    y1: 100.35,
    x2: 134.506,
    y2: 100.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63709D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#63709D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1415_3219",
    x1: 253.199,
    y1: 208.393,
    x2: 261.798,
    y2: 210.233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F2F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1415_3219",
    x1: 84.0449,
    y1: 127.093,
    x2: 243.781,
    y2: 127.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#191D36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191D36",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1415_3219",
    x1: 214.553,
    y1: 152.719,
    x2: 158.396,
    y2: 161.469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1415_3219",
    x1: 114.926,
    y1: 111.164,
    x2: 183.066,
    y2: 117.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20AC87",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474067,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20AC87",
    stopOpacity: 0.65
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1415_3219",
    x1: 24.5839,
    y1: 143.397,
    x2: 28.4294,
    y2: 143.397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30313A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#232429"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1415_3219",
    x1: 24.7129,
    y1: 139.952,
    x2: 27.9079,
    y2: 139.952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30313A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#232429"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1415_3219",
    x1: 25.1944,
    y1: 146.687,
    x2: 26.8451,
    y2: 146.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#30313A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#232429"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1415_3219",
    x1: 24.1367,
    y1: 140.217,
    x2: 27.3318,
    y2: 140.217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#30313A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#232429"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1415_3219",
    x1: 24.1367,
    y1: 139.269,
    x2: 27.3318,
    y2: 139.269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F2F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1415_3219",
    x1: 24.2037,
    y1: 147.18,
    x2: 28.1126,
    y2: 147.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30313A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#232429"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1415_3219",
    x1: 269.181,
    y1: 240.655,
    x2: 296.218,
    y2: 308.266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1415_3219",
    x1: 389.544,
    y1: 245.08,
    x2: 272.341,
    y2: 264.585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F2647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE8C66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1415_3219",
    x1: 225.866,
    y1: 211.005,
    x2: 240.45,
    y2: 214.124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F2F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1415_3219",
    x1: 378.977,
    y1: 115.945,
    x2: 383.489,
    y2: 115.945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8935F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9744A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1415_3219",
    x1: 383.49,
    y1: 116.246,
    x2: 388.122,
    y2: 116.246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E5434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F3D26"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1415_3219",
    x1: 354.322,
    y1: 114.154,
    x2: 401.81,
    y2: 114.154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8935F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9744A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1415_3219",
    x1: 359.191,
    y1: 112.777,
    x2: 363.076,
    y2: 112.777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AA0C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B4F7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1415_3219",
    x1: 359.492,
    y1: 111.584,
    x2: 362.78,
    y2: 111.584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AA0C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B4F7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1415_3219",
    x1: 359.791,
    y1: 110.389,
    x2: 362.481,
    y2: 110.389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AA0C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B4F7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_1415_3219",
    x1: 369.385,
    y1: 116.275,
    x2: 373.27,
    y2: 116.275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AA0C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B4F7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_1415_3219",
    x1: 369.682,
    y1: 115.08,
    x2: 372.969,
    y2: 115.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AA0C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B4F7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_1415_3219",
    x1: 369.982,
    y1: 113.885,
    x2: 372.672,
    y2: 113.885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AA0C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B4F7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_1415_3219",
    x1: 396.521,
    y1: 125.629,
    x2: 400.407,
    y2: 125.629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AA0C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B4F7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_1415_3219",
    x1: 396.818,
    y1: 124.434,
    x2: 400.106,
    y2: 124.434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AA0C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B4F7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_1415_3219",
    x1: 397.119,
    y1: 123.238,
    x2: 399.809,
    y2: 123.238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AA0C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B4F7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_1415_3219",
    x1: 368.039,
    y1: 146.07,
    x2: 380.591,
    y2: 146.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECE6E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#D6D0D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A09CA6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_1415_3219",
    x1: 367.594,
    y1: 143.891,
    x2: 381.042,
    y2: 143.891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B2430"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1C1830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#171D45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_1415_3219",
    x1: 370.729,
    y1: 142.754,
    x2: 372.223,
    y2: 142.754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AA0C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B4F7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_1415_3219",
    x1: 376.408,
    y1: 144.008,
    x2: 377.902,
    y2: 144.008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AA0C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B4F7E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfferReviewComparisonSolarHouse);
export default __webpack_public_path__ + "static/media/offer-review-comparison-solar-house.2e7fde40a8e75dd9d337248aa3db909d.svg";
export { ForwardRef as ReactComponent };